import styled from 'styled-components'

export const StyledFormActionWrapper = styled.div`
  margin: 16px 0;
  display: flex;
  justify-content: flex-end;

  button {
    margin: 0 4px;
    &[type='submit'] {
      min-width: 200px;
    }
  }
` as any
